// src/hooks/useNextcloud.js
// Hook providing Nextcloud connection state across the app

import { useState, useCallback, useEffect } from "react";
import {
  getCredentials,
  clearCredentials,
  startLogin,
} from "../services/nextcloudService.js";

export const useNextcloud = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [loginName, setLoginName] = useState("");
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState(null);

  // Check localStorage on mount
  useEffect(() => {
    const creds = getCredentials();
    if (creds) {
      setIsConnected(true);
      setLoginName(creds.loginName);
    }
  }, []);

  const connect = useCallback(async () => {
    setConnecting(true);
    setError(null);
    try {
      const result = await startLogin();
      setIsConnected(true);
      setLoginName(result.loginName);
    } catch (err) {
      setError(err.message);
    } finally {
      setConnecting(false);
    }
  }, []);

  const disconnect = useCallback(() => {
    clearCredentials();
    setIsConnected(false);
    setLoginName("");
    setError(null);
  }, []);

  return {
    isConnected,
    loginName,
    connecting,
    error,
    connect,
    disconnect,
  };
};
